import React from "react";
import { classNames } from "../../helpers/classNames";

const Container = ({ children, className }) => {
  return (
    <div
      className={classNames(
        "w-full h-full mx-auto flex",
        className
      )}
    >
      {children}
    </div>
  );
};

export default Container;
